export function iso8601ToDate(iso: string | null): Date | null {
  if (!iso) return null;
  const date = new Date(iso);
  return isNaN(date.getTime()) ? null : date;
}

export function millisecondsToTime(ms: number) {
  const seconds = Math.floor(ms / 1000);
  const minutes = Math.floor(seconds / 60);
  const hours = Math.floor(minutes / 60);
  const days = Math.floor(hours / 24);

  return {
    days: days,
    hours: hours % 24,
    minutes: minutes % 60,
    seconds: seconds % 60,
    milliseconds: ms % 1000,
  };
}

export function formatDate(input: string | Date): string {
  const months: string[] = [
    "янв", "фев", "мар", "апр", "мая", "июн",
    "июл", "авг", "сен", "окт", "ноя", "дек"
  ];

  const date: Date = (input instanceof Date) ? input : new Date(input);

  const day: number = date.getUTCDate();
  const month: string = months[date.getUTCMonth()];

  return `${day} ${month}.`;
}

